import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Redirect, Link } from "react-router-dom";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

function AllCategoryTicket() {
  const [categoriesTicket, setCategoriesTicket] = useState();

  useEffect(() => {
    getCategoriesTickets();
  }, []);

  const deleteCategoryTicket = async (categoryTicketID) => {
    const result = window.confirm("آیا مطمئن هستید؟");
    if (!result) {
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestDeleteCategoryTicket(categoryTicketID)) {
      getCategoriesTickets();
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestDeleteCategoryTicket = async (categoryTicketID) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/ticket/categories-ticket/" +
          categoryTicketID,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getCategoriesTickets = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categoriesTicket = await sendRequestGetCategoriesTickets();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setCategoriesTicket(generateTagsHtmlCategoriesTickets(categoriesTicket));
  };

  const generateTagsHtmlCategoriesTickets = (categoriesTicket) => {
    return categoriesTicket.map((categoryTicket, index) => {
      return (
        <tr>
          <td>{index + 1}</td>
          <td>{categoryTicket.id}</td>
          <td>{categoryTicket.title}</td>

          <td>
            <div>
              <span className="pl-2">
                <Link
                  to={"/ticket/category-ticket/edit/" + categoryTicket.id}
                  className="btn btn-outline-success  "
                >
                  <i className="fa fa-edit"></i>
                </Link>
              </span>

              <span>
                <span
                  className="btn btn-outline-danger  btn-danger"
                  onClick={() => deleteCategoryTicket(categoryTicket.id)}
                >
                  <i className="fa fa-trash"></i>
                </span>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const sendRequestGetCategoriesTickets = async () => {
    const headersRequest = getHeaderForRequest();
    let categoriesTicket;
    try {
      categoriesTicket = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/ticket/categories-ticket",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoriesTicket.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="manage-tickets" activeItem="all-category-ticket" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">دسته بندی تیکت</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-3">
                <Link
                  to="/ticket/category-ticket/add"
                  className="btn btn-outline-info"
                >
                  <span className="pl-2">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>دسته جدید</span>
                </Link>
              </div>
              <div className="table-responsive">
                <table className="table table-hilite tbl-td-white-space ">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره دسته</td>
                      <td>عنوان دسته</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>

                  <tbody>{categoriesTicket} </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllCategoryTicket;
